import {
  getEventUserType,
  GTM_CLICK_EVENT,
  sendGTMBasicPageViewEvent,
  sendGTMCustomClickEvent,
} from '../../../../helpers/gtmHelper'
import { STUDENT_BTN_ID, STUDENT_PAGE_VIEW_ID } from '../../../../modules/ids/gtm/student'

import { useEffect } from 'react'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { s_home } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import CenterContainer from '../../../common/CenterContainer'
import Titles from '../../../landing-legacy/Titles'
import TutorCardTab from '../../../landing-legacy/TutorCardTab'
import { IMG_ENGLISH_TUTOR_DESKTOP_HERO } from '../../constants/home.constants'
import LandingNav from '../../navigation/LandingNav'
import Footer from '../../section/footer'

type EnglishTutorBodyV2Props = {
  variation: string
}

const EnglishTutorBodyV2: React.FC<EnglishTutorBodyV2Props> = ({ variation }) => {
  const router = useAppRouter()
  const { t, locale } = useTranslation()
  const { currentUser } = useCurrentUser()

  const handleClickCtaBtn = (btnName: string) => {
    sendGTMCustomClickEvent(
      GTM_CLICK_EVENT.CLICK_LANDING_BUTTON,
      STUDENT_BTN_ID.ClICK_START_RINGLE,
      btnName,
      getEventUserType(currentUser),
      `${router.asPath.substring(1).split('/').join('-')}${variation ? ` - ${variation}` : ''}`,
      router.asPath
    )

    router.push(urls.student.auth.new)
  }

  useEffect(() => {
    // Set Scroll To Top
    window.scrollTo(0, 0)

    sendGTMBasicPageViewEvent(
      STUDENT_PAGE_VIEW_ID.LANDING_ENGLISH_TUTORS,
      getEventUserType(currentUser),
      locale,
      `${router.asPath.substring(1).split('/').join('-')}${variation ? ` - ${variation}` : ''}`,
      router.asPath
    )
  }, [])

  return (
    <div className="w-screen bg-white">
      <LandingNav />

      <div className="flex w-full items-center justify-center bg-[#281E66]">
        <div className="flex min-h-[360px] w-full max-w-[1440px] items-center justify-between px-20">
          <div className="px-[80px]">
            <h1 className="whitespace-pre-line text-[36px] font-bold leading-[140%] text-white">
              {t(s_home.tutor_page.title.desktop)}
            </h1>
            <button
              className="text-16 mt-[41px] min-w-[266px] rounded-[29px] bg-white py-[18px] font-bold leading-[160%] text-purple-500"
              onClick={() => handleClickCtaBtn('무료로 튜터 먼저 둘러보기')}
            >
              {t(s_home.tutor_page.cta.desktop)}
            </button>
          </div>
          <div
            className="h-[360px] max-w-[796px] flex-1 bg-cover bg-center"
            style={{ backgroundImage: `url(${IMG_ENGLISH_TUTOR_DESKTOP_HERO})` }}
          />
        </div>
      </div>

      <div className="mt-28 w-screen bg-white px-24">
        <CenterContainer className="py-96 text-center">
          <Titles title={<>{t(s_home.tutors_title)}</>} subtitle={<>{t(s_home.tutors_subtitle)}</>} />
          <TutorCardTab />
        </CenterContainer>
      </div>

      <div className="mt-[30px] flex flex-col items-center justify-center pb-[200px]">
        <h2 className="text-32 text-center font-bold leading-[140%] text-black">
          {t(s_home.tutor_page.subtitle.desktop)}
        </h2>
        <button
          className="text-16 mt-24 min-w-[170px] rounded-[29px] bg-[#4130A4] py-16 px-16 font-bold leading-[160%] text-white"
          onClick={() => handleClickCtaBtn('지금 시작하기')}
        >
          {t(s_home.tutor_page.cta.desktop)}
        </button>
        <div className="mt-[40px]">
          <div className="Title2-18Md text-center">{t(s_home.tutor_page.subtitle2.desktop)}</div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default EnglishTutorBodyV2
